import React, { FC, ReactNode } from 'react';
import styled, { css } from 'styled-components';

const StyledContent = styled.div<{ $leftColumnWidth?: string; $middleColumnWidth?: string }>`
  position: relative;
  display: grid;
  grid-template-columns: ${({ $leftColumnWidth, $middleColumnWidth }) =>
    `${$leftColumnWidth ?? '20%'}${$middleColumnWidth ? ` minmax(0, ${$middleColumnWidth})` : ''} minmax(0, 1fr)`};
  gap: ${({ theme }) => theme.spacing.medium};
  /* margin-top: ${({ theme }) => theme.spacing.medium}; */
  transition: grid-template-columns 0.2s ease;

  > * {
    min-width: 0;
  }

  aside {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.medium};
  }

  @media (max-width: 1500px) {
    grid-template-columns: ${({ $leftColumnWidth, $middleColumnWidth }) =>
      `${$leftColumnWidth ?? '30%'}${$middleColumnWidth ? ` minmax(0, ${$middleColumnWidth})` : ''} minmax(0, 1fr)`};
  }

  ${({ $middleColumnWidth, $leftColumnWidth }) =>
    $middleColumnWidth &&
    css`
      @media (max-width: 1300px) {
        grid-template-columns: ${$leftColumnWidth ?? '30%'} minmax(0, ${$middleColumnWidth}) minmax(0, 1fr);
      }
    `}

  @media (max-width: 1077px) {
    grid-template-columns: 1fr;
  }
`;

interface NgGridLayoutProps {
  children?: ReactNode;
  leftColumnWidth?: string;
  middleColumnWidth?: string;
}

export const NgGridLayout: FC<NgGridLayoutProps> = ({ children, leftColumnWidth, middleColumnWidth }) => {
  return (
    <StyledContent $leftColumnWidth={leftColumnWidth} $middleColumnWidth={middleColumnWidth}>
      {children}
    </StyledContent>
  );
};
